import { Moment } from 'moment'

import { DefaultFile } from 'Core/constants'
import { ConfigFilterItem, ConfigItem, MultipleDefaultFile } from 'Core/interfaces'

import { Contact } from './Contact'

export enum SupplierRequestFields {
	id = 'id',
	status = 'status',
	supplierName = 'supplierName',
	serviceSite = 'serviceSite',
	programManager = 'programManager',
	assignedTo = 'assignedTo',
	createDate = 'createDate',
	createdBy = 'createdBy',
	lastUpdatedBy = 'lastUpdatedBy',
	lastUpdateDate = 'lastUpdateDate'
}

export enum DetailedSupplierRequestFields {
	id = 'id',
	status = 'status',
	supplierName = 'supplierName',
	serviceSite = 'serviceSite',
	assignedTo = 'assignedTo',
	serviceScopes = 'serviceScopes',
	acceptableMaterialsForTheCompany = 'acceptableMaterialsForTheCompany',
	contractedPricing = 'contractedPricing',
	supplierUsageJustification = 'supplierUsageJustification',
	supplierUsageJustificationExplanation = 'supplierUsageJustificationExplanation',
	supplierPhoneNumber = 'supplierPhoneNumber',
	supplierWebsiteAddress = 'supplierWebsiteAddress',
	supplierEmailAddress = 'supplierEmailAddress',
	supplierContact = 'supplierContact',
	addressLine1 = 'addressLine1',
	addressLine2 = 'addressLine2',
	stateProvince = 'stateProvince',
	city = 'city',
	zipCode = 'zipCode',
	county = 'county',
	category = 'category',
	createDate = 'createDate',
	createdBy = 'createdBy',
	lastUpdatedBy = 'lastUpdatedBy',
	lastUpdateDate = 'lastUpdateDate',
	riskTier = 'riskTier',
	rebatesIncentives = 'rebatesIncentives',
	notes = 'notes',
	auditType = 'auditType',
	auditDocuments = 'auditDocuments',
	auditNotes = 'auditNotes',
	dbaCompanyName = 'dbaCompanyName',
	yearCompanyEstablished = 'yearCompanyEstablished',
	numberOfEmployeesFrom = 'numberOfEmployeesFrom',
	numberOfEmployeesTo = 'numberOfEmployeesTo',
	legalStructure = 'legalStructure',
	legalStructureExplanation = 'legalStructureExplanation',
	epaId = 'epaId',
	transporterEpaId = 'transporterEpaId',
	transporterDotLicenceNumber = 'transporterDotLicenceNumber',
	psLegalName = 'psLegalName',
	psPayTerms = 'psPayTerms',
	psSupplierRequestDiversity = 'psSupplierRequestDiversity',
	psCodeOfConductAcceptance = 'psCodeOfConductAcceptance',
	psRemittanceAddress1 = 'psRemittanceAddress1',
	psRemittanceAddress2 = 'psRemittanceAddress2',
	psStateProvince = 'psStateProvince',
	psCity = 'psCity',
	psZipCode = 'psZipCode',
	psCounty = 'psCounty',
	csrSustainabilityPrograms = 'csrSustainabilityPrograms',
	otherReportingAssessments = 'otherReportingAssessments',
	ethicalPolicies = 'ethicalPolicies',
	engagedInSupplyChainTopics = 'engagedInSupplyChainTopics',
	qualityCertificationsAvailable = 'qualityCertificationsAvailable',
	qualityCertifications = 'qualityCertifications',
	qualityCertExplanationOfOther = 'qualityCertExplanationOfOther',
	environmentalManagementSystem = 'environmentalManagementSystem',
	employmentPolicies = 'employmentPolicies',
	companyReceivedFines = 'companyReceivedFines',
	issuesAddressesByCompanySafetyProgram = 'issuesAddressesByCompanySafetyProgram',
	processOfAddressingComplaints = 'processOfAddressingComplaints',
	primaryWayOfSatisfactionLevelDetermination = 'primaryWayOfSatisfactionLevelDetermination',
	emrRateEnabled = 'emrRateEnabled',
	emrEmptyReason = 'emrEmptyReason',
	emrEmptyOtherReason = 'emrEmptyOtherReason',
	oshaRateEnabled = 'oshaRateEnabled',
	oshaEmptyReason = 'oshaEmptyReason',
	oshaEmptyOtherReason = 'oshaEmptyOtherReason',
	emrOshaRates = 'emrOshaRates',
	regDocSubmissionCount = 'regDocSubmissionCount'
}

export enum SupplierRequestSearchFields {
	supplierName = 'searchBySupplierName',
	serviceSiteId = 'searchByServiceSiteId',
	serviceSiteName = 'searchByServiceSiteName'
}

export enum SupplierRequestFilterFields {
	createdDateFrom = 'createdDateFrom',
	createdDateTo = 'createdDateTo',
	status = 'statusId',
	programManger = 'programManagerId',
	assignedTo = 'assignedToId'
}

export enum SupplierRequestBasicMainFormFields {
	requestCategory = 'requestCategory',
	intendedForServiceSite = 'intendedForServiceSite',
	programManager = 'programManager',
	assignTo = 'assignTo',
	contractedPricing = 'contractedPricing',
	supplierUsageJustification = 'supplierUsageJustification',
	supplierUsageJustificationOtherExplanation = 'supplierUsageJustificationOtherExplanation',
	scopeOfService = 'scopeOfService'
}

export enum SupplierRequestBasicSupplierDetailsSectionFormFields {
	supplierName = 'supplierName',
	supplierEmailAddress = 'supplierEmailAddress',
	supplierPhoneNumber = 'supplierPhoneNumber',
	supplierWebsiteAddress = 'supplierWebsiteAddress',
	supplierContact = 'supplierContact',
	changeUserTypeToNewSupplier = 'changeUserTypeToNewSupplier'
}

export enum SupplierRequestEditSupplierDetailsSectionFormFields {
	supplierContactPhoneNumber = 'supplierContactPhoneNumber',
	supplierContactEmailAddress = 'supplierContactEmailAddress'
}

export enum SupplierRequestBasicSupplierAddressSectionFormFields {
	addressLine1 = 'addressLine1',
	addressLine2 = 'addressLine2',
	stateProvince = 'stateProvince',
	city = 'city',
	zipCode = 'zipCode',
	county = 'county'
}

export enum SupplierRequestEditFormFields {
	lastEditedBy = 'lastEditedBy',
	dateLastUpdated = 'dateLastUpdated',
	createdBy = 'createdBy',
	createDate = 'createDate',
	acceptableMaterialsForCompany = 'acceptableMaterialsForCompany'
}

export enum SupplierRequestBasicRiskAssessmentFields {
	anticipatedRiskTier = 'anticipatedRiskTier',
	rebates = 'rebates',
	notes = 'notes'
}

export enum SupplierRequestBasicAuditFields {
	auditType = 'auditType',
	notes = 'auditNotes',
	documents = 'documents'
}

export enum SupplierRequestApproveFormFields {
	supplierId = 'supplierId',
	companyId = 'companyId',
	supplierLocations = 'supplierLocations'
}
export enum SupplierRequestBasicAdditionalInfoFields {
	dbaCompanyNames = 'dbaCompanyNames',
	yearCompanyEstablished = 'yearCompanyEstablished',
	numberOfEmployeesCompanyWide = 'numberOfEmployeesCompanyWide',
	legalStructure = 'legalStructure',
	otherExplanationOfLegalStructure = 'otherExplanationOfLegalStructure',
	epaId = 'epaId',
	transporterEpaId = 'transporterEpaId',
	transporterDOTLicenseNumber = 'transporterDOTLicenseNumber'
}

export enum SupplierRequestBasicPSDetailsFields {
	fullLegalName = 'fullLegalName',
	payTerms = 'peyTerms',
	diversityChoices = 'diversityChoices',
	supplierCode = 'supplierCode',
	remittanceAddress1 = 'remittanceAddress1',
	remittanceAddress2 = 'remittanceAddress2',
	stateProvince = 'psStateProvince',
	city = 'psCity',
	zipCode = 'psZipCode',
	county = 'psCounty'
}

export enum SupplierRequestBasicProgramsFields {
	csrSustainabilityPrograms = 'csrSustainabilityPrograms',
	otherReportingOrAssessments = 'otherReportingOrAssessments',
	isSustainable = 'isSustainable',
	ethicalPoliciesCommunications = 'ethicalPoliciesCommunications'
}

export enum SupplierRequestBasicCommitmentFields {
	isCertifications = 'isCertifications',
	certifications = 'certifications',
	otherExplanationsOfCertifications = 'otherExplanationsOfCertifications',
	environmentalManagementSystem = 'environmentalManagementSystem',
	isCompanyReceivedIssues = 'isCompanyReceivedIssues',
	employmentPolicies = 'employmentPolicies',
	issues = 'issues',
	process = 'process',
	primaryWay = 'primaryWay',
	isEMRRate = 'isEMRRate',
	reasonEMR = 'reasonEMR',
	otherExplanationOfReasonEMR = 'otherExplanationOfReasonEMR',
	isOSHARecordableRate = 'isOSHARecordableRate',
	reasonOSHA = 'reasonOSHA',
	otherExplanationOfReasonOSHA = 'otherExplanationOfReasonOSHA',
	rates = 'rates'
}

export enum SupplierRequestDocumentFields {
	id = 'id',
	documentType = 'documentType',
	documentName = 'documentName',
	uploadedBy = 'uploadedBy',
	uploadDate = 'uploadDate',
	isRequired = 'isRequired',
	addedFromRegDoc = 'addedFromRegDoc',
	updatedFromRegDoc = 'updatedFromRegDoc'
}

export enum SupplierRequestUploadDocumentFormFields {
	documentType = 'documentType',
	document = 'document'
}

export enum SupplierRequestAdditionalLocationFormFields {
	id = 'id',
	locationName = 'locationName',
	siteContactName = 'siteContactName',
	siteContactPhoneNumber = 'siteContactPhoneNumber',
	addressLine1 = 'addressLine1',
	addressLine2 = 'addressLine2',
	stateProvinceId = 'stateProvinceId',
	city = 'city',
	zipCode = 'zipCode',
	countryId = 'countryId',
	countyId = 'countyId',
	remitAddressLine1 = 'remitAddressLine1',
	remitAddressLine2 = 'remitAddressLine2',
	remitStateProvinceId = 'remitStateProvinceId',
	remitCity = 'remitCity',
	remitZipCode = 'remitZipCode',
	remitCountryId = 'remitCountryId',
	remitCountyId = 'remitCountyId',
	remitEmailAddress = 'remitEmailAddress',
	numberOfEmployeesFrom = 'numberOfEmployeesFrom',
	numberOfEmployeesTo = 'numberOfEmployeesTo',
	epaId = 'epaId',
	usDotNumber = 'usDotNumber',
	w9EinNumber = 'w9EinNumber',
	employeeRangeId = 'employeeRangeId',
	addedFromRegDoc = 'addedFromRegDoc',
	updatedFromRegDoc = 'updatedFromRegDoc'
}

export enum SupplierRequestAdditionalLocationFields {
	id = 'id',
	locationName = 'locationName',
	siteContactName = 'siteContactName',
	siteContactPhoneNumber = 'siteContactPhoneNumber',
	addressLine1 = 'addressLine1',
	addressLine2 = 'addressLine2',
	stateProvince = 'stateProvince',
	city = 'city',
	zipCode = 'zipCode',
	addedFromRegDoc = 'addedFromRegDoc',
	updatedFromRegDoc = 'updatedFromRegDoc'
}

export enum SupplierRequestStatuses {
	Created = 'Created',
	Approved = 'Approved',
	Rejected = 'Rejected',
	Requested = 'Requested',
	UpdatedBySupplier = 'Updated By Supplier'
}

export enum SupplierRequestChangeStatusFormFields {
	note = 'note'
}

export enum SupplierRequestCommentFormFields {
	comment = 'comment'
}

export enum SupplierRequestReassignFormFields {
	reassignTo = 'reassignTo',
	notes = 'notes'
}

export enum ChangeLogType {
	status = 'STATUS',
	assignment = 'ASSIGNMENT',
	comment = 'COMMENT'
}

export enum AuditTypeLabels {
	noAudit = 'No audit',
	paperAudit = 'Paper audit',
	paperPhysicalAudit = 'Paper&Physical audit'
}

export enum RisKTierLabels {
	one = '1',
	two = '2',
	threeA = '3A',
	threeB = '3B',
	four = '4',
	five = '5',
	sixA = '6A',
	sixB = '6B'
}

export enum DocumentTypeLabels {
	w9 = 'W9',
	proofOfInsurance = 'Proof of Insurance',
	certificateOfInsurance = 'Certificate of Insurance',
	contract = 'Contract',
	nda = 'NDA',
	transportationContingencySpillPlan = 'Transportation Contingency Spill Plan',
	CSRSustainabilityPrograms = 'CSR/Sustainability Programs',
	safety = 'Safety',
	other = 'Other'
}

export enum ScopeOfServiceLabels {
	transportationHaz = 'TRANSPORTATION - HAZ',
	transportationNonHaz = 'TRANSPORTATION - NON-HAZ'
}

export declare namespace SupplierRequest {
	type EntityName = 'SupplierRequest'

	interface PersonBasic {
		id: number
		firstName: BasicString
		lastName: BasicString
	}

	interface AssignedTo extends PersonBasic {
		isBusinessManager: boolean
	}

	interface ServiceSiteSuggestionsEntity extends Entity {
		programManager: PersonBasic
	}

	interface IntendedForServiceSiteSuggestions {
		searchById: ServiceSiteSuggestionsEntity[]
		searchByName: ServiceSiteSuggestionsEntity[]
	}

	interface Document {
		[SupplierRequestDocumentFields.id]: number
		[SupplierRequestDocumentFields.documentType]: Entity | null
		[SupplierRequestDocumentFields.documentName]: BasicString
		[SupplierRequestDocumentFields.uploadedBy]: PersonBasic | null
		[SupplierRequestDocumentFields.uploadDate]: BasicString
		[SupplierRequestDocumentFields.isRequired]: boolean
		[SupplierRequestDocumentFields.addedFromRegDoc]: boolean
		[SupplierRequestDocumentFields.updatedFromRegDoc]: boolean
	}

	interface Basic {
		[SupplierRequestFields.id]: number
		[SupplierRequestFields.status]: Entity | null
		[SupplierRequestFields.supplierName]: BasicString
		[SupplierRequestFields.serviceSite]: Entity | null
		[SupplierRequestFields.programManager]: PersonBasic | null
		[SupplierRequestFields.assignedTo]: PersonBasic | null
		[SupplierRequestFields.createDate]: BasicString
		[SupplierRequestFields.createdBy]: PersonBasic | null
		[SupplierRequestFields.lastUpdatedBy]: PersonBasic | null
		[SupplierRequestFields.lastUpdateDate]: BasicString
	}

	interface SupplierContact extends PersonBasic {
		emailAddress: BasicString
		mobilePhone: BasicString
	}

	interface Rate {
		id: number
		emrRate: BasicString
		oshaRate: BasicString
		lostTimeRate: BasicString
		fatalities: BasicString
		year: number
	}

	interface Detailed {
		[DetailedSupplierRequestFields.id]: number
		[DetailedSupplierRequestFields.status]: Entity<SupplierRequestStatuses>
		[DetailedSupplierRequestFields.supplierName]: BasicString
		[DetailedSupplierRequestFields.serviceSite]: ServiceSiteSuggestionsEntity | null
		[DetailedSupplierRequestFields.assignedTo]: PersonBasic
		[DetailedSupplierRequestFields.serviceScopes]: Entity[]
		[DetailedSupplierRequestFields.acceptableMaterialsForTheCompany]: BasicString
		[DetailedSupplierRequestFields.contractedPricing]: BasicString
		[DetailedSupplierRequestFields.supplierUsageJustification]: Entity | null
		[DetailedSupplierRequestFields.supplierUsageJustificationExplanation]: BasicString
		[DetailedSupplierRequestFields.supplierPhoneNumber]: BasicString
		[DetailedSupplierRequestFields.supplierWebsiteAddress]: BasicString
		[DetailedSupplierRequestFields.supplierEmailAddress]: BasicString
		[DetailedSupplierRequestFields.supplierContact]: SupplierContact | null
		[DetailedSupplierRequestFields.addressLine1]: BasicString
		[DetailedSupplierRequestFields.addressLine2]: BasicString
		[DetailedSupplierRequestFields.stateProvince]: Entity | null
		[DetailedSupplierRequestFields.city]: BasicString
		[DetailedSupplierRequestFields.zipCode]: BasicString
		[DetailedSupplierRequestFields.county]: Entity | null
		[DetailedSupplierRequestFields.category]: Entity | null
		[DetailedSupplierRequestFields.createDate]: BasicString
		[DetailedSupplierRequestFields.createdBy]: PersonBasic | null
		[DetailedSupplierRequestFields.lastUpdatedBy]: PersonBasic | null
		[DetailedSupplierRequestFields.lastUpdateDate]: BasicString
		[DetailedSupplierRequestFields.riskTier]: Entity
		[DetailedSupplierRequestFields.rebatesIncentives]: BasicString
		[DetailedSupplierRequestFields.notes]: BasicString
		[DetailedSupplierRequestFields.auditType]: Entity | null
		[DetailedSupplierRequestFields.auditDocuments]: Entity[]
		[DetailedSupplierRequestFields.auditNotes]: BasicString

		[DetailedSupplierRequestFields.dbaCompanyName]: BasicString
		[DetailedSupplierRequestFields.yearCompanyEstablished]: number
		[DetailedSupplierRequestFields.numberOfEmployeesFrom]: BasicNumber
		[DetailedSupplierRequestFields.numberOfEmployeesTo]: BasicNumber
		[DetailedSupplierRequestFields.legalStructure]: Entity | null
		[DetailedSupplierRequestFields.legalStructureExplanation]: BasicString
		[DetailedSupplierRequestFields.epaId]: BasicString
		[DetailedSupplierRequestFields.transporterEpaId]: BasicString
		[DetailedSupplierRequestFields.transporterDotLicenceNumber]: BasicString

		[DetailedSupplierRequestFields.psLegalName]: BasicString
		[DetailedSupplierRequestFields.psPayTerms]: BasicString
		[DetailedSupplierRequestFields.psSupplierRequestDiversity]: Entity | null
		[DetailedSupplierRequestFields.psCodeOfConductAcceptance]: BasicString
		[DetailedSupplierRequestFields.psRemittanceAddress1]: BasicString
		[DetailedSupplierRequestFields.psRemittanceAddress2]: BasicString
		[DetailedSupplierRequestFields.psStateProvince]: Entity | null
		[DetailedSupplierRequestFields.psCity]: BasicString
		[DetailedSupplierRequestFields.psZipCode]: BasicString
		[DetailedSupplierRequestFields.psCounty]: Entity | null

		[DetailedSupplierRequestFields.csrSustainabilityPrograms]: Entity[] | null
		[DetailedSupplierRequestFields.otherReportingAssessments]: BasicString
		[DetailedSupplierRequestFields.ethicalPolicies]: Entity[] | null
		[DetailedSupplierRequestFields.engagedInSupplyChainTopics]: boolean | null

		[DetailedSupplierRequestFields.emrOshaRates]: Rate[]
		[DetailedSupplierRequestFields.emrRateEnabled]: boolean
		[DetailedSupplierRequestFields.emrEmptyReason]: Entity | null
		[DetailedSupplierRequestFields.emrEmptyOtherReason]: BasicString
		[DetailedSupplierRequestFields.oshaRateEnabled]: boolean
		[DetailedSupplierRequestFields.oshaEmptyReason]: Entity | null
		[DetailedSupplierRequestFields.oshaEmptyOtherReason]: BasicString
		[DetailedSupplierRequestFields.companyReceivedFines]: boolean
		[DetailedSupplierRequestFields.employmentPolicies]: Entity[]
		[DetailedSupplierRequestFields.issuesAddressesByCompanySafetyProgram]: Entity[]
		[DetailedSupplierRequestFields.processOfAddressingComplaints]: BasicString
		[DetailedSupplierRequestFields.primaryWayOfSatisfactionLevelDetermination]: BasicString

		[DetailedSupplierRequestFields.qualityCertificationsAvailable]: boolean
		[DetailedSupplierRequestFields.qualityCertifications]: Entity[]
		[DetailedSupplierRequestFields.qualityCertExplanationOfOther]: BasicString
		[DetailedSupplierRequestFields.environmentalManagementSystem]: BasicString

		[DetailedSupplierRequestFields.regDocSubmissionCount]: BasicNumber
	}

	interface ChangesToAcknowledge extends Detailed {
		uploadedDocuments: Document[]
		additionalLocations: AdditionalLocation.Detailed[]
	}

	namespace ChangeLog {
		interface Basic {
			changeLogType: ChangeLogType
			createBy: PersonBasic
			createDate: BasicString
			notes: BasicString
		}

		interface Status extends Basic {
			oldStatus: Entity<SupplierRequestStatuses>
			newStatus: Entity<SupplierRequestStatuses>
		}

		interface Reassign extends Basic {
			oldAssignee: PersonBasic
			newAssignee: PersonBasic
		}

		type All = Status | Reassign
	}

	namespace Search {
		interface Config {
			[SupplierRequestSearchFields.supplierName]: ConfigItem<SupplierRequestSearchFields>
			[SupplierRequestSearchFields.serviceSiteId]: ConfigItem<
				SupplierRequestSearchFields,
				Entity
			>
			[SupplierRequestSearchFields.serviceSiteName]: ConfigItem<SupplierRequestSearchFields>
		}

		interface Result {
			[SupplierRequestSearchFields.supplierName]: Entity[]
			[SupplierRequestSearchFields.serviceSiteId]: Entity[]
			[SupplierRequestSearchFields.serviceSiteName]: Entity[]
		}
	}

	namespace Filter {
		interface Config {
			[SupplierRequestFilterFields.createdDateFrom]: ConfigFilterItem<string, null>
			[SupplierRequestFilterFields.createdDateTo]: ConfigFilterItem<string, null>
			[SupplierRequestFilterFields.status]: ConfigFilterItem<string, string>
			[SupplierRequestFilterFields.programManger]: ConfigFilterItem<string, string>
			[SupplierRequestFilterFields.assignedTo]: ConfigFilterItem<string, string>
		}
	}

	namespace Form {
		interface Basic {
			[SupplierRequestBasicMainFormFields.requestCategory]: BasicString
			[SupplierRequestBasicMainFormFields.intendedForServiceSite]: LabelValue | null
			[SupplierRequestBasicMainFormFields.programManager]: BasicString
			[SupplierRequestBasicMainFormFields.assignTo]: BasicString
			[SupplierRequestBasicMainFormFields.contractedPricing]: BasicString
			[SupplierRequestBasicMainFormFields.supplierUsageJustification]: BasicString
			[SupplierRequestBasicMainFormFields.supplierUsageJustificationOtherExplanation]: BasicString
			[SupplierRequestBasicMainFormFields.scopeOfService]: LabelValue[]
			[SupplierRequestBasicSupplierDetailsSectionFormFields.supplierName]: BasicString
			[SupplierRequestBasicSupplierDetailsSectionFormFields.supplierEmailAddress]: BasicString
			[SupplierRequestBasicSupplierDetailsSectionFormFields.supplierPhoneNumber]: BasicString
			[SupplierRequestBasicSupplierDetailsSectionFormFields.supplierWebsiteAddress]: BasicString
			[SupplierRequestBasicSupplierDetailsSectionFormFields.supplierContact]: Nullable<
				LabelValue & {
					user: Contact.UserType
				}
			>
			[SupplierRequestBasicSupplierDetailsSectionFormFields.changeUserTypeToNewSupplier]: boolean

			[SupplierRequestBasicSupplierAddressSectionFormFields.addressLine1]: BasicString
			[SupplierRequestBasicSupplierAddressSectionFormFields.addressLine2]: BasicString
			[SupplierRequestBasicSupplierAddressSectionFormFields.stateProvince]: BasicString
			[SupplierRequestBasicSupplierAddressSectionFormFields.city]: BasicString
			[SupplierRequestBasicSupplierAddressSectionFormFields.zipCode]: BasicString
			[SupplierRequestBasicSupplierAddressSectionFormFields.county]: BasicString
		}

		namespace Add {
			interface Valid extends Basic {
				[SupplierRequestBasicMainFormFields.requestCategory]: string
				[SupplierRequestBasicMainFormFields.intendedForServiceSite]: LabelValue
				[SupplierRequestBasicMainFormFields.assignTo]: string
				[SupplierRequestBasicMainFormFields.contractedPricing]: string
				[SupplierRequestBasicMainFormFields.supplierUsageJustification]: string
				[SupplierRequestBasicSupplierDetailsSectionFormFields.supplierName]: string
				[SupplierRequestBasicSupplierDetailsSectionFormFields.supplierEmailAddress]: string
				[SupplierRequestBasicSupplierDetailsSectionFormFields.supplierPhoneNumber]: string
				[SupplierRequestBasicSupplierDetailsSectionFormFields.supplierWebsiteAddress]: string
				[SupplierRequestBasicSupplierDetailsSectionFormFields.supplierContact]: LabelValue & {
					user: Contact.UserType
				}
				[SupplierRequestBasicSupplierAddressSectionFormFields.addressLine1]: string
				[SupplierRequestBasicSupplierAddressSectionFormFields.stateProvince]: string
				[SupplierRequestBasicSupplierAddressSectionFormFields.city]: string
				[SupplierRequestBasicSupplierAddressSectionFormFields.zipCode]: string
			}
		}

		namespace Edit {
			interface Basic extends Form.Basic {
				isRequiredSchema: boolean
				[SupplierRequestEditFormFields.acceptableMaterialsForCompany]: BasicString
				[SupplierRequestEditFormFields.lastEditedBy]: BasicString
				[SupplierRequestEditFormFields.dateLastUpdated]: BasicString
				[SupplierRequestEditFormFields.createdBy]: BasicString
				[SupplierRequestEditFormFields.createDate]: BasicString
				[SupplierRequestEditSupplierDetailsSectionFormFields.supplierContactPhoneNumber]: BasicString
				[SupplierRequestEditSupplierDetailsSectionFormFields.supplierContactEmailAddress]: BasicString
				[SupplierRequestBasicRiskAssessmentFields.anticipatedRiskTier]: BasicString
				[SupplierRequestBasicRiskAssessmentFields.rebates]: BasicString
				[SupplierRequestBasicRiskAssessmentFields.notes]: BasicString
				[SupplierRequestBasicAuditFields.auditType]: BasicString
				[SupplierRequestBasicAuditFields.notes]: BasicString
				[SupplierRequestBasicAuditFields.documents]: MultipleDefaultFile | null

				[SupplierRequestBasicAdditionalInfoFields.dbaCompanyNames]: BasicString
				[SupplierRequestBasicAdditionalInfoFields.yearCompanyEstablished]: Moment | null
				[SupplierRequestBasicAdditionalInfoFields.numberOfEmployeesCompanyWide]: BasicString
				[SupplierRequestBasicAdditionalInfoFields.legalStructure]: LabelValue<number> | null
				[SupplierRequestBasicAdditionalInfoFields.otherExplanationOfLegalStructure]: BasicString
				[SupplierRequestBasicAdditionalInfoFields.epaId]: BasicString
				[SupplierRequestBasicAdditionalInfoFields.transporterEpaId]: BasicString
				[SupplierRequestBasicAdditionalInfoFields.transporterDOTLicenseNumber]: BasicString

				[SupplierRequestBasicProgramsFields.csrSustainabilityPrograms]:
					| LabelValue<number>[]
					| null
				[SupplierRequestBasicProgramsFields.otherReportingOrAssessments]: BasicString
				[SupplierRequestBasicProgramsFields.ethicalPoliciesCommunications]:
					| LabelValue<number>[]
					| null
				[SupplierRequestBasicProgramsFields.isSustainable]: boolean

				[SupplierRequestBasicPSDetailsFields.fullLegalName]: BasicString
				[SupplierRequestBasicPSDetailsFields.payTerms]: BasicString
				[SupplierRequestBasicPSDetailsFields.diversityChoices]: BasicString
				[SupplierRequestBasicPSDetailsFields.supplierCode]: Moment | null
				[SupplierRequestBasicPSDetailsFields.remittanceAddress1]: BasicString
				[SupplierRequestBasicPSDetailsFields.remittanceAddress2]: BasicString
				[SupplierRequestBasicPSDetailsFields.stateProvince]: BasicString
				[SupplierRequestBasicPSDetailsFields.city]: BasicString
				[SupplierRequestBasicPSDetailsFields.zipCode]: BasicString
				[SupplierRequestBasicPSDetailsFields.county]: BasicString

				[SupplierRequestBasicCommitmentFields.isCertifications]: boolean
				[SupplierRequestBasicCommitmentFields.certifications]: LabelValue<number>[]
				[SupplierRequestBasicCommitmentFields.otherExplanationsOfCertifications]: BasicString
				[SupplierRequestBasicCommitmentFields.environmentalManagementSystem]: BasicString
				[SupplierRequestBasicCommitmentFields.isCompanyReceivedIssues]: boolean
				[SupplierRequestBasicCommitmentFields.employmentPolicies]:
					| LabelValue<number>[]
					| null
				[SupplierRequestBasicCommitmentFields.issues]: LabelValue<number>[] | null
				[SupplierRequestBasicCommitmentFields.process]: BasicString
				[SupplierRequestBasicCommitmentFields.primaryWay]: BasicString
				[SupplierRequestBasicCommitmentFields.isEMRRate]: boolean
				[SupplierRequestBasicCommitmentFields.reasonEMR]: LabelValue<number> | null
				[SupplierRequestBasicCommitmentFields.otherExplanationOfReasonEMR]: BasicString
				[SupplierRequestBasicCommitmentFields.isOSHARecordableRate]: boolean
				[SupplierRequestBasicCommitmentFields.reasonOSHA]: LabelValue<number> | null
				[SupplierRequestBasicCommitmentFields.otherExplanationOfReasonOSHA]: BasicString
				[SupplierRequestBasicCommitmentFields.rates]: Rate[]
			}

			interface Valid extends Basic {
				[SupplierRequestEditFormFields.acceptableMaterialsForCompany]: string
				[SupplierRequestBasicMainFormFields.requestCategory]: string
				[SupplierRequestBasicMainFormFields.intendedForServiceSite]: LabelValue
				[SupplierRequestBasicMainFormFields.assignTo]: string
				[SupplierRequestBasicMainFormFields.contractedPricing]: string
				[SupplierRequestBasicMainFormFields.supplierUsageJustification]: string
				[SupplierRequestBasicSupplierDetailsSectionFormFields.supplierName]: string
				[SupplierRequestBasicSupplierDetailsSectionFormFields.supplierEmailAddress]: string
				[SupplierRequestBasicSupplierDetailsSectionFormFields.supplierPhoneNumber]: string
				[SupplierRequestBasicSupplierDetailsSectionFormFields.supplierWebsiteAddress]: string
				[SupplierRequestBasicSupplierDetailsSectionFormFields.supplierContact]: LabelValue
				[SupplierRequestBasicSupplierAddressSectionFormFields.addressLine1]: string
				[SupplierRequestBasicSupplierAddressSectionFormFields.stateProvince]: string
				[SupplierRequestBasicSupplierAddressSectionFormFields.city]: string
				[SupplierRequestBasicSupplierAddressSectionFormFields.zipCode]: string
				[SupplierRequestBasicRiskAssessmentFields.anticipatedRiskTier]: string
				[SupplierRequestBasicAuditFields.auditType]: string
				[SupplierRequestBasicAdditionalInfoFields.numberOfEmployeesCompanyWide]: string
				[SupplierRequestBasicAdditionalInfoFields.legalStructure]: LabelValue<number>
				[SupplierRequestBasicPSDetailsFields.fullLegalName]: string
				[SupplierRequestBasicPSDetailsFields.payTerms]: string
				[SupplierRequestBasicPSDetailsFields.supplierCode]: Moment
				[SupplierRequestBasicPSDetailsFields.remittanceAddress1]: string
				[SupplierRequestBasicPSDetailsFields.stateProvince]: string
				[SupplierRequestBasicPSDetailsFields.city]: string
				[SupplierRequestBasicPSDetailsFields.zipCode]: string
			}
		}
	}

	namespace UploadDocument {
		namespace Form {
			interface Basic {
				[SupplierRequestUploadDocumentFormFields.documentType]: BasicString
				[SupplierRequestUploadDocumentFormFields.document]: DefaultFile | null
			}

			interface Valid extends Basic {
				[SupplierRequestUploadDocumentFormFields.documentType]: string
				[SupplierRequestUploadDocumentFormFields.document]: DefaultFile
			}
		}

		namespace Request {
			interface Add {
				documentTypeId: number
				file: File
			}
		}
	}

	namespace AdditionalLocation {
		interface Basic {
			[SupplierRequestAdditionalLocationFields.id]: number
			[SupplierRequestAdditionalLocationFields.locationName]: BasicString
			[SupplierRequestAdditionalLocationFields.siteContactName]: BasicString
			[SupplierRequestAdditionalLocationFields.siteContactPhoneNumber]: BasicString
			[SupplierRequestAdditionalLocationFields.addressLine1]: BasicString
			[SupplierRequestAdditionalLocationFields.addressLine2]: BasicString
			[SupplierRequestAdditionalLocationFields.stateProvince]: BasicString
			[SupplierRequestAdditionalLocationFields.city]: BasicString
			[SupplierRequestAdditionalLocationFields.zipCode]: BasicString
			[SupplierRequestAdditionalLocationFields.addedFromRegDoc]: boolean
			[SupplierRequestAdditionalLocationFields.updatedFromRegDoc]: boolean
		}

		interface Detailed {
			[SupplierRequestAdditionalLocationFormFields.id]: number
			[SupplierRequestAdditionalLocationFormFields.locationName]: BasicString
			[SupplierRequestAdditionalLocationFormFields.siteContactName]: BasicString
			[SupplierRequestAdditionalLocationFormFields.siteContactPhoneNumber]: BasicString
			[SupplierRequestAdditionalLocationFormFields.addressLine1]: BasicString
			[SupplierRequestAdditionalLocationFormFields.addressLine2]: BasicString
			[SupplierRequestAdditionalLocationFormFields.stateProvinceId]: BasicString
			[SupplierRequestAdditionalLocationFormFields.city]: BasicString
			[SupplierRequestAdditionalLocationFormFields.zipCode]: BasicString
			[SupplierRequestAdditionalLocationFormFields.countryId]: BasicString
			[SupplierRequestAdditionalLocationFormFields.countyId]: BasicString
			[SupplierRequestAdditionalLocationFormFields.remitAddressLine1]: BasicString
			[SupplierRequestAdditionalLocationFormFields.remitAddressLine2]: BasicString
			[SupplierRequestAdditionalLocationFormFields.remitStateProvinceId]: BasicString
			[SupplierRequestAdditionalLocationFormFields.remitCity]: BasicString
			[SupplierRequestAdditionalLocationFormFields.remitZipCode]: BasicString
			[SupplierRequestAdditionalLocationFormFields.remitCountryId]: BasicString
			[SupplierRequestAdditionalLocationFormFields.remitCountyId]: BasicString
			[SupplierRequestAdditionalLocationFormFields.remitEmailAddress]: BasicString
			[SupplierRequestAdditionalLocationFormFields.numberOfEmployeesFrom]: BasicNumber
			[SupplierRequestAdditionalLocationFormFields.numberOfEmployeesTo]: BasicNumber
			[SupplierRequestAdditionalLocationFormFields.epaId]: BasicString
			[SupplierRequestAdditionalLocationFormFields.usDotNumber]: BasicString
			[SupplierRequestAdditionalLocationFormFields.w9EinNumber]: BasicString
			[SupplierRequestAdditionalLocationFormFields.employeeRangeId]: BasicNumber
			[SupplierRequestAdditionalLocationFormFields.addedFromRegDoc]: boolean
			[SupplierRequestAdditionalLocationFormFields.updatedFromRegDoc]: boolean
		}
		namespace Form {
			interface Basic {
				[SupplierRequestAdditionalLocationFormFields.locationName]: BasicString
				[SupplierRequestAdditionalLocationFormFields.siteContactName]: BasicString
				[SupplierRequestAdditionalLocationFormFields.siteContactPhoneNumber]: BasicString
				[SupplierRequestAdditionalLocationFormFields.addressLine1]: BasicString
				[SupplierRequestAdditionalLocationFormFields.addressLine2]: BasicString
				[SupplierRequestAdditionalLocationFormFields.stateProvinceId]: BasicString
				[SupplierRequestAdditionalLocationFormFields.city]: BasicString
				[SupplierRequestAdditionalLocationFormFields.zipCode]: BasicString
				[SupplierRequestAdditionalLocationFormFields.countryId]: BasicString
				[SupplierRequestAdditionalLocationFormFields.countyId]: BasicString
				[SupplierRequestAdditionalLocationFormFields.remitAddressLine1]: BasicString
				[SupplierRequestAdditionalLocationFormFields.remitAddressLine2]: BasicString
				[SupplierRequestAdditionalLocationFormFields.remitStateProvinceId]: BasicString
				[SupplierRequestAdditionalLocationFormFields.remitCity]: BasicString
				[SupplierRequestAdditionalLocationFormFields.remitZipCode]: BasicString
				[SupplierRequestAdditionalLocationFormFields.remitCountryId]: BasicString
				[SupplierRequestAdditionalLocationFormFields.remitCountyId]: BasicString
				[SupplierRequestAdditionalLocationFormFields.remitEmailAddress]: BasicString
				[SupplierRequestAdditionalLocationFormFields.numberOfEmployeesFrom]: BasicNumber
				[SupplierRequestAdditionalLocationFormFields.numberOfEmployeesTo]: BasicNumber
				[SupplierRequestAdditionalLocationFormFields.epaId]: BasicString
				[SupplierRequestAdditionalLocationFormFields.usDotNumber]: BasicString
				[SupplierRequestAdditionalLocationFormFields.w9EinNumber]: BasicString
				[SupplierRequestAdditionalLocationFormFields.employeeRangeId]?: BasicNumber
			}

			interface Request {
				[SupplierRequestAdditionalLocationFormFields.locationName]: BasicString
				[SupplierRequestAdditionalLocationFormFields.siteContactName]: BasicString
				[SupplierRequestAdditionalLocationFormFields.siteContactPhoneNumber]: BasicString
				[SupplierRequestAdditionalLocationFormFields.addressLine1]: BasicString
				[SupplierRequestAdditionalLocationFormFields.addressLine2]: BasicString
				[SupplierRequestAdditionalLocationFormFields.stateProvinceId]: BasicNumber
				[SupplierRequestAdditionalLocationFormFields.city]: BasicString
				[SupplierRequestAdditionalLocationFormFields.zipCode]: BasicString
				[SupplierRequestAdditionalLocationFormFields.countryId]: BasicNumber
				[SupplierRequestAdditionalLocationFormFields.countyId]: BasicNumber
				[SupplierRequestAdditionalLocationFormFields.remitAddressLine1]: BasicString
				[SupplierRequestAdditionalLocationFormFields.remitAddressLine2]: BasicString
				[SupplierRequestAdditionalLocationFormFields.remitStateProvinceId]: BasicNumber
				[SupplierRequestAdditionalLocationFormFields.remitCity]: BasicString
				[SupplierRequestAdditionalLocationFormFields.remitZipCode]: BasicString
				[SupplierRequestAdditionalLocationFormFields.remitCountryId]: BasicNumber
				[SupplierRequestAdditionalLocationFormFields.remitCountyId]: BasicNumber
				[SupplierRequestAdditionalLocationFormFields.remitEmailAddress]: BasicString
				[SupplierRequestAdditionalLocationFormFields.numberOfEmployeesFrom]: BasicNumber
				[SupplierRequestAdditionalLocationFormFields.numberOfEmployeesTo]: BasicNumber
				[SupplierRequestAdditionalLocationFormFields.epaId]: BasicString
				[SupplierRequestAdditionalLocationFormFields.usDotNumber]: BasicString
				[SupplierRequestAdditionalLocationFormFields.w9EinNumber]: BasicString
			}
		}
	}

	namespace Request {
		interface Add {
			categoryId: number
			serviceSiteId: BasicNumber
			serviceScopes: number[]
			contractedPricing: BasicString
			supplierUsageJustificationId: BasicNumber
			supplierUsageJustificationExplanation: BasicString
			assignedToId: number
			supplierName: BasicString
			supplierPhoneNumber: BasicString
			supplierWebsiteAddress: BasicString
			supplierEmailAddress: BasicString
			supplierContactId: BasicNumber
			addressLine1: BasicString
			addressLine2: BasicString
			stateProvinceId: BasicNumber
			city: BasicString
			zipCode: BasicString
			countyId: BasicNumber
		}

		interface Edit {
			categoryId: number
			serviceSiteId: BasicNumber
			serviceScopes: number[]
			acceptableMaterialsForTheCompany: BasicString
			contractedPricing: BasicString
			supplierUsageJustificationId: BasicNumber
			supplierUsageJustificationExplanation: BasicString
			supplierName: BasicString
			supplierContactId: BasicNumber
			supplierPhoneNumber: BasicString
			supplierWebsiteAddress: BasicString
			supplierEmailAddress: BasicString
			addressLine1: BasicString
			addressLine2: BasicString
			stateProvinceId: BasicNumber
			city: BasicString
			zipCode: BasicString
			countyId: BasicNumber
			riskTierId: BasicNumber
			rebatesIncentives: BasicString
			notes: BasicString
			auditTypeId: BasicNumber
			existingAuditDocuments: number[]
			UploadedAuditDocuments: File[]
			auditNotes: BasicString

			dbaCompanyName: BasicString
			yearCompanyEstablished: BasicNumber
			numberOfEmployeesFrom: BasicNumber
			numberOfEmployeesTo: BasicNumber
			legalStructureId: number
			legalStructureExplanation: BasicString
			epaId: BasicString
			transporterEpaId: BasicString
			transporterDotLicenceNumber: BasicString

			pSLegalName: BasicString
			pSPayTerms: BasicString
			pSSupplierRequestDiversityId: BasicNumber
			pSCodeOfConductAcceptance: BasicString
			pSRemittanceAddress1: BasicString
			pSRemittanceAddress2: BasicString
			pSStateProvinceId: BasicNumber
			pSCity: BasicString
			pSZipCode: BasicString
			pSCountyId: BasicNumber

			qualityCertificationsAvailable: boolean
			qualityCertifications: number[] | null
			qualityCertExplanationOfOther: BasicString
			environmentalManagementSystem: BasicString
			emrRateEnabled: boolean
			emrEmptyReasonId: number | null
			emrEmptyOtherReason: BasicString
			oshaRateEnabled: boolean
			oshaEmptyReasonId: number | null
			oshaEmptyOtherReason: BasicString
			employmentPolicies: number[] | null
			companyReceivedFines: boolean
			issuesAddressesByCompanySafetyProgram: number[] | null
			processOfAddressingComplaints: BasicString
			primaryWayOfSatisfactionLevelDetermination: BasicString

			csrSustainabilityPrograms: number[] | null
			otherReportingAssessments: BasicString
			ethicalPolicies: number[] | null
			engagedInSupplyChainTopics: boolean | null
		}

		interface AddCreatedStatus extends Omit<Add, 'assignedToId'> {}
	}

	namespace ChangeStatus {
		namespace Form {
			interface Basic {
				[SupplierRequestChangeStatusFormFields.note]: string
			}
		}

		namespace Request {
			interface Generic {
				notes: BasicString
			}
		}

		namespace Approve {
			interface Form {
				[SupplierRequestApproveFormFields.supplierId]: BasicNumber
				[SupplierRequestApproveFormFields.companyId]: BasicNumber
				[SupplierRequestApproveFormFields.supplierLocations]: number[] | undefined
			}

			interface Request {
				[SupplierRequestApproveFormFields.supplierId]: BasicNumber
				[SupplierRequestApproveFormFields.companyId]: BasicNumber
				[SupplierRequestApproveFormFields.supplierLocations]: number[] | null
			}
		}
	}

	namespace Comment {
		interface Basic {
			id: number
			entityId: number
			entityType: Entity
			author: string
			commentText: string
			createDate: string
			updatedDate: string
		}

		namespace Form {
			interface Add {
				[SupplierRequestCommentFormFields.comment]: string
			}
		}

		namespace Request {
			interface Add {
				entityId: number
				entityType: SupplierRequest.EntityName
				commentText: string
			}
		}
	}

	namespace Reassign {
		namespace Form {
			interface Add {
				[SupplierRequestReassignFormFields.reassignTo]: number | null
				[SupplierRequestReassignFormFields.notes]: BasicString
			}
		}

		namespace Request {
			interface Add {
				assignedToId: number
				notes: BasicString
			}
		}
	}
}
